module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nQLmnn/tc-custom/9781452126210.jpg?1729185361688",
      "alt": "This image is the cover for the book Cat Getting Out of a Bag and Other Observations"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cat Getting Out of a Bag and Other Observations\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The celebrated comic artist and graphic novelist explores the unique joys of living with a cat in this delightful collection.")]), _c('br'), _c('br'), _vm._v(" Featured in "), _c('i', [_vm._v("McSweeney’s")]), _vm._v(" and on NPR’s "), _c('i', [_vm._v("This American Life")]), _vm._v(", Jeffrey Brown’s work has always paid tribute to felines as they curl up on couches and purr on the peripheries of his autobiographical stories. "), _c('i', [_vm._v("Cat Getting Out of a Bag")]), _vm._v(" follows his cat Misty—really, any cat—as she goes about her everyday activities and adventures. In a series of drawings, Brown perfectly captures the universal charm of cats in a lovely book sure to please fans and cat lovers of any stripe.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeffrey Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jeffrey Brown has written and illustrated numerous graphic novels and comics, and his work has been widely anthologized. He lives in Chicago.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0